import React from "react";
import "./services.css";
import { motion } from "framer-motion/dist/framer-motion";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const Services = () => {
  return (
    <div className="services" id="services">
      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="service-header"
      >
        Services
      </motion.h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid
        ratione aut, neque maiores facere aperiam
      </p>
      <div className="services-cards">
        <div className="services-card">
          <Card
            style={{ background: "#111921", padding: 10 }}
            sx={{ maxWidth: 280 }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              height="200"
              image="https://img.freepik.com/free-vector/space-background-with-abstract-shape-stars_189033-30.jpg?w=2000"
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                color="white"
                component="div"
              >
                Galaxy
              </Typography>
              <Typography variant="body2" color="gray">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Aliquid ratione aut, neque maiores facere aperiam,
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                style={{
                  background: "transparent",
                  border: "1px solid white",
                  padding: "5px 30px",
                  color: "white",
                }}
                size="small"
              >
                Learn More
              </Button>
            </CardActions>
          </Card>
        </div>
        <div className="services-card">
          <Card
            style={{ background: "#111921", padding: 10 }}
            sx={{ maxWidth: 280 }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              height="200"
              image="https://c4.wallpaperflare.com/wallpaper/910/878/466/atmosphere-satellite-space-tech-outer-space-wallpaper-preview.jpg"
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                color="white"
                component="div"
              >
                Space Tech
              </Typography>
              <Typography variant="body2" color="gray">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Aliquid ratione aut, neque maiores facere aperiam,
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                style={{
                  background: "transparent",
                  border: "1px solid white",
                  padding: "5px 30px",
                  color: "white",
                }}
                size="small"
              >
                Learn More
              </Button>
            </CardActions>
          </Card>
        </div>
        <div className="services-card">
          <Card
            style={{ background: "#111921", padding: 10 }}
            sx={{ maxWidth: 280 }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              height="200"
              image="https://evolutionnews.org/wp-content/uploads/2017/08/Infinity-Room.jpg"
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                color="white"
                component="div"
              >
                Multiverse
              </Typography>
              <Typography variant="body2" color="gray">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Aliquid ratione aut, neque maiores facere aperiam,
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                style={{
                  background: "transparent",
                  border: "1px solid white",
                  padding: "5px 30px",
                  color: "white",
                }}
                size="small"
              >
                Learn More
              </Button>
            </CardActions>
          </Card>
        </div>
        <div className="services-card">
          <Card
            style={{ background: "#111921", padding: 10 }}
            sx={{ maxWidth: 280 }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              height="200"
              image="https://helios-i.mashable.com/imagery/articles/044yNuoS9mc0SH0KArOcSVS/hero-image.fill.size_1248x702.v1629127813.jpg"
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                color="white"
                component="div"
              >
                Planets
              </Typography>
              <Typography variant="body2" color="gray">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Aliquid ratione aut, neque maiores facere aperiam,
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                style={{
                  background: "transparent",
                  border: "1px solid white",
                  padding: "5px 30px",
                  color: "white",
                }}
                size="small"
              >
                Learn More
              </Button>
            </CardActions>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Services;
